/**
 * CompanyPicker — prosty dropdown wyboru firmy po id.
 *
 * Reużywalny w miejscach, gdzie encja jest przypisana do JEDNEJ firmy (np.
 * DocumentTypeFormModal — F20 T20.19/T20D). Stylistyka zgodna z `LookupSelect`
 * (apps/admin/src/components/employees/employeeEngineConfig.tsx) — zwykły
 * `<select>`, bez wyszukiwarki/comboboxa (lista firm tenanta jest mała).
 */

import { useTranslation } from 'react-i18next';

import { Dropdown, type DropdownOption } from '@/components/Dropdown';

export interface CompanyPickerOption {
  id: string;
  legalName: string;
}

interface CompanyPickerProps {
  value: string | null;
  onChange: (id: string | null) => void;
  companies: CompanyPickerOption[];
  disabled?: boolean;
  required?: boolean;
  testId?: string;
}

export function CompanyPicker({
  value,
  onChange,
  companies,
  disabled = false,
  required = false,
  testId,
}: CompanyPickerProps) {
  const { t } = useTranslation();
  const options: DropdownOption[] = [
    // Opcjonalny: „nie ustawiono". Wymagany bez wyboru: placeholder jako pusta opcja
    // (spójnie ze starym natywnym `<select>` — pusty string = brak wskazania).
    ...(!required ? [{ value: '', label: t('common.notSet') }] : []),
    ...(required && !value ? [{ value: '', label: t('common.selectPlaceholder') }] : []),
    ...companies.map((c) => ({ value: c.id, label: c.legalName })),
  ];
  return (
    <Dropdown
      value={value ?? ''}
      onChange={(v) => onChange(v || null)}
      disabled={disabled}
      data-testid={testId}
      options={options}
    />
  );
}
